import { Component } from '@theme/component';

class UgcCarousel extends Component {
  requiredRefs = ['stage', 'prev', 'next'];
  #activeCard = null;

  connectedCallback() {
    super.connectedCallback();
    this.#updateArrows();
    this.refs.stage.addEventListener('scroll', () => this.#updateArrows(), { passive: true });
    this.#observeVideos();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer?.disconnect();
  }

  handlePrev() {
    const stage = this.refs.stage;
    const card = stage.querySelector('.ugc-fan__card');
    if (!card) return;
    stage.scrollBy({ left: -(card.offsetWidth + 16), behavior: 'smooth' });
  }

  handleNext() {
    const stage = this.refs.stage;
    const card = stage.querySelector('.ugc-fan__card');
    if (!card) return;
    stage.scrollBy({ left: card.offsetWidth + 16, behavior: 'smooth' });
  }

  handleCardClick(event) {
    const card = event.target.closest('.ugc-fan__card');
    if (!card) return;

    const video = card.querySelector('video');
    if (!video) return;

    const modal = this.querySelector('.ugc-fan__modal');
    const modalVideo = modal.querySelector('video');
    const caption = card.querySelector('.ugc-fan__caption');
    const shade = card.querySelector('.ugc-fan__shade');
    const modalCaption = modal.querySelector('.ugc-fan__modal-caption');
    const modalShade = modal.querySelector('.ugc-fan__modal-shade');

    // Pause the thumbnail preview
    video.pause();

    modalVideo.innerHTML = video.innerHTML;
    modalVideo.poster = video.poster || '';
    modalVideo.load();
    modalVideo.currentTime = 0;
    modalVideo.muted = false;
    modalVideo.play();

    if (modalCaption) modalCaption.textContent = caption ? caption.textContent : '';
    if (modalShade) modalShade.textContent = shade ? shade.textContent : '';

    this.#activeCard = card;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  handleCloseModal() {
    const modal = this.querySelector('.ugc-fan__modal');
    const modalVideo = modal.querySelector('video');
    modalVideo.pause();
    modal.hidden = true;
    document.body.style.overflow = '';

    // Resume thumbnail preview from the start
    if (this.#activeCard) {
      const video = this.#activeCard.querySelector('video');
      if (video) {
        video.currentTime = 0;
        video.play();
      }
      this.#activeCard = null;
    }
  }

  /** @type {IntersectionObserver|null} */
  #observer = null;

  #observeVideos() {
    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        }
      },
      { threshold: 0.25 }
    );

    this.querySelectorAll('.ugc-fan__video').forEach((video) => {
      this.#observer.observe(video);
    });
  }

  #updateArrows() {
    const { stage, prev, next } = this.refs;
    const atStart = stage.scrollLeft <= 1;
    const atEnd = stage.scrollLeft + stage.offsetWidth >= stage.scrollWidth - 1;
    prev.disabled = atStart;
    next.disabled = atEnd;
  }
}

customElements.define('ugc-carousel-component', UgcCarousel);
